'use strict';

const _ = require('lodash');
const Enum = require('./enum');
const BridgesConstants = require('./bridges');
const LocksConstants = require('./locks');
const DoorbellsConstants = require('./doorbells');

/**
 * Defines devices.
 *
 * @enum
 * @readonly
 */
const Devices = Object.create(Enum, {
  BRIDGE: { value: 'connect', enumerable: true },
  LOCK: { value: 'lock', enumerable: true },
  LOCK_AND_BRIDGE_V5: { value: 'lock_v5', enumerable: true },
  LOCK_AND_BRIDGE_V1005: { value: 'lock_v1005', enumerable: true },
  KEYPAD: { value: 'keypad', enumerable: true },
  DOORBELL: { value: DoorbellsConstants.DoorbellVersions.V1, enumerable: true },
  DOORBELL_V2: { value: DoorbellsConstants.DoorbellVersions.V2, enumerable: true },
  DOORBELL_V3: { value: DoorbellsConstants.DoorbellVersions.V3, enumerable: true },
  DOORBELL_V4: { value: DoorbellsConstants.DoorbellVersions.V4, enumerable: true },
  DOORBELL_V5: { value: DoorbellsConstants.DoorbellVersions.V5, enumerable: true },
  DOORBELL_V6: { value: DoorbellsConstants.DoorbellVersions.V6, enumerable: true },
  DOOR_POSITION_SENSOR: { value: 'dps', enumerable: true },
  CHIME: { value: 'chime', enumerable: true },
  CAMERA: { value: 'camera', enumerable: true },
  HOMEKIT: { value: 'homekit', enumerable: true },
  ALEXA: { value: 'alexa', enumerable: true },
  VALET: { value: 'valet', enumerable: true },
  NONE: { value: 'none', enumerable: true },
  ALARM: { value: 'alarm', enumerable: true },

  // window actuator system(WA)
  WA_HUB: { value: 'wa_hub', enumerable: true },
  WA_REMOTE: { value: 'wa_remote', enumerable: true },
  WA_ACTUATOR: { value: 'wa_actuator', enumerable: true },
  WA_ZIGBEE_MODULE: { value: 'wa_zigbee_module', enumerable: true },
  WA_SYSTEM: { value: 'wa_system', enumerable: true },

  hasClientCertificate: {
    value: function(device) {
      return DoorbellsConstants.DoorbellVersions.hasClientCertificate(device);
    },
    enumerable: false,
  },
  supportsTcpKeepAlive: {
    value: function(device) {
      const hasCaps = _.get(device, 'caps', []).includes('tcp_wakeup');

      return hasCaps || _.get(device, 'serialNumber', '').startsWith('D3');
    },
    enumerable: false,
  },
});

const DeviceMonitorEvents = Object.create(Enum, {
  LONGPOLL_OK_TELEMETRY_TIMEOUT: { value: 'longpoll_ok_telemetry_timeout', enumerable: true },
  LONGPOLL_TIMEOUT_TELEMETRY_OK: { value: 'longpoll_timeout_telemetry_ok', enumerable: true },
});

/**
 * Defines identifiers to distinguish between
 * devices versions.
 *
 * @enum
 * @readonly
 */
const DevicesVersions = Object.create(Enum, {
  getBridgeType: {
    value: function(bridge) {
      switch (bridge.deviceModel) {
        case BridgesConstants.BridgeDeviceModelTypes.AUGUST_CONNECT:
          return Devices.BRIDGE;
        case BridgesConstants.BridgeDeviceModelTypes.AUGUST_DOORBELL:
          if (/^D1/.test(bridge.mfgBridgeID)) {
            return Devices.DOORBELL;
          }
          if (/^D2/.test(bridge.mfgBridgeID)) {
            return Devices.DOORBELL_V2;
          }
          if (/^D3/.test(bridge.mfgBridgeID)) {
            return Devices.DOORBELL_V3;
          }

          return Devices.NONE;
        case BridgesConstants.BridgeDeviceModelTypes.AUGUST_LOCK:
          return LocksConstants.LockVersions.V5;
        case BridgesConstants.BridgeDeviceModelTypes.CORONADO:
          return BridgesConstants.BridgeDeviceModelTypes.CORONADO;

        default:
          return Devices.NONE;
      }
    },
  },
  deviceToVersionString: {
    value: function(device) {
      const serialNumber = (_.get(device, 'mfgBridgeID') || _.get(device, 'serialNumber', '')).toUpperCase();

      switch (true) {
        case /^C/.test(serialNumber):
          return BridgesConstants.BridgeVersions.typeToVersionString(device.Type || 1);

        case /^D/.test(serialNumber):
          return DoorbellsConstants.DoorbellVersions.getVersionFromDoorbellObject(device);

        case /^(B1U|L|M|Q|S|Y)/.test(serialNumber):
          return LocksConstants.LockVersions.typeToVersionString(device.Type);

        default:
          return null;
      }
    },
  },
});

exports.SubscriptionTypes = Object.create(Enum, {
  ZUORA: { value: 'zuora', enumerable: true },
  RECURLY: { value: 'recurly', enumerable: true },
});

exports.Devices = Devices;
exports.DeviceMonitorEvents = DeviceMonitorEvents;
exports.DevicesVersions = DevicesVersions;

exports.SLIDING_RATE_LIMIT_WIFIKEY_SOFTAPV4_KEY_PREFIX = 'SLIDING_LIMIT:WIFIKEY:SOFTAPV4:';
